export const APP_NAME = 'Admin Portal'

export const ACTION = {
  // Actions used to track Event on Login Routes
  CLICKED_SIGNIN: 'Clicked Sign In',
  CLICKED_FORGOT_PASSWORD: 'Clicked Forgot Password?',
  CLICKED_NEED_HELP: 'Clicked Need Help?',
  CLICKED_TERMS_SERVICE: 'Clicked Terms of Service',
  CLICKED_PRIVACY_POLICY: 'Clicked Privacy Policy',
  CLICKED_SSO: 'Clicked SSO',
  CLICKED_INTERNAL_SSO: 'Clicked Internal SSO',
  CLICKED_LOGOUT: 'Clicked Logout',

  //Action use to track event on dashboard routes
  CLICKED_DASHBOARD: 'Clicked Dashboard',
  SELECTED_DASHBOARD: 'Selected Dashboard',
  SELECTED_GROUP: 'Selected Group',
  CLICKED_SAVE: 'Clicked Save',
  ENABLE_MFA: 'Enable MFA',
  DISABLE_MFA: 'Disable MFA',
  CLICKED_USERS: 'Clicked Users',

  // Actions used to track Event on Users Routes
  CLICKED_ADD: "Clicked '+'",
  CLICKED_PERMISSION_GROUP: 'Clicked Permission Group',
  USER_TEAM_ADMIN: 'Selected Yes to Is this user a Team Admin for this group',
  USER_NOT_TEAM_ADMIN: 'Selected No  Is this user a Team Admin for this group',
  SAVE_USER: 'Clicked Save and add user',
  CLICKED_USER: 'Clicked User',
  ACTIVE_USER: 'Selected Yes Is current User Active',
  NOT_ACTIVE_USER: 'Selected No Is current User Active',
  CURRENT_USER_LOCKED: '	Selected Yes Is current User Locked',
  CURRENT_USER_NOT_LOCKED: 'Selected No Is current User Locked',
  CLICKED_SAVE_UPDATE: 'Clicked Save Updates',
  CLICKEKD_REMOVE_USER: 'Clicked Remove User',
  CLICKED_GROUP: 'Clicked Group',
  SELECT_GROUP: 'Select group',

  //Action used to track event on help routes
  CLICKED_HELP: 'Clicked Help',
  ENTERED_SEARCH: 'Entered Search',
  CLICKED_CONTACT_US: 'Clicked Contact Us',
}
